import { getGoldenChallenges } from "./get";
import type { GoldenChallengeOption } from "./types";

export interface GoldenChallengeSuggestion {
  id: string;
  content: string;
  options: GoldenChallengeOption[];
}

export const getGoldenChallengeSuggestions = async ({
  grade,
  lesson,
}: { grade?: number; lesson?: string } = {}): Promise<GoldenChallengeSuggestion[]> => {

  const params: { grade?: number; lesson?: string } = {};
  if (grade) params.grade = grade;
  if (lesson) params.lesson = lesson;

  const { items } = await getGoldenChallenges({ params });

  return items
    .map((item) => ({
      id: String(item.id),
      content: item.content,
      options: item.options ?? [],
    }))
    .filter((suggestion) => suggestion.content);
};
